import { useState } from "react"
import TermsModal from "../components/TermsModal"
import PrivacyModal from "../components/PrivacyModal"
import { ChannelTalk } from "@/lib/channel"

export default function Footer() {
    const [showTerms, setShowTerms] = useState(false)
    const [showPrivacy, setShowPrivacy] = useState(false)

    // 채널톡 열기 함수
    const openChannelTalk = () => {
        ChannelTalk.open()
    }

    return (
        <footer className="text-sm text-gray-400 py-6 border-t mt-12">
            <div className="container mx-auto px-4">
                <div className="max-w-3xl mx-auto space-y-2">
                    <p className="text-center text-md text-gray-400 mt-4">
                        {new Date().getFullYear()} Copyright ⓒ Queddar. All rights reserved
                    </p>

                    <p className="text-center">상호: 꿰다(Queddar) | 대표자: 김태완 | 사업자등록번호: 592-54-00934</p>
                    <p className="text-center">주소: 경기도 용인시 수지구 광교마을로 62, 21층 | 전화번호: 010-2988-3712 | 통신판매업신고번호: 2026-용인수지-1209</p>
                    <p className="text-center">이메일: contact@queddar.com</p>
                    <div className="flex gap-4 mt-2 cursor-pointer justify-center text-gray-400">
                        <span onClick={() => setShowTerms(true)}>이용약관</span>
                        <span onClick={() => setShowPrivacy(true)}>개인정보처리방침</span>
                        <span onClick={openChannelTalk}>고객센터</span>
                    </div>
                </div>
            </div>
            {showTerms && <TermsModal onClose={() => setShowTerms(false)} />}
            {showPrivacy && <PrivacyModal onClose={() => setShowPrivacy(false)} />}
        </footer>
    )
} 